import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const MOTORCYCLE = {
  nickname: 'PRODUCTS.MOTORCYCLE.shortname',
  properties: [
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.7.5', value: '7500' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.15', value: '15000' },
        ]
      }
    },
    { name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-50', value: '-50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-40', value: '-40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-30', value: '-30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-20', value: '-20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-10', value: '-10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_1', value: '70,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_2', value: '70,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_3', value: '70,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_1', value: '75,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_2', value: '75,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3', value: '75,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3+', value: '75,3+' },
        ]
      }
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.LAGRING', value: 'LAGRING' },
        ]
      }
    },
    {
      name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.YOUNG_DRIVER.DRIVER_UNDER_25', value: 'DRIVER_UNDER_25' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.YOUNG_DRIVER.NO_DRIVER_UNDER_25', value: 'NO_DRIVER_UNDER_25' },
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      MOTORCYCLE: true,
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    {
      name: 'licenseYear', key: 'DRIVER_LICENSE_YEAR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    { name: 'tffVehicleEnginePower', key: 'TFF_VEHICLE_ENGINE_POWER', group: 'OBJECT_INFO' },
    { name: 'tffVehicleWeight', key: 'TFF_VEHICLE_WEIGHT', group: 'OBJECT_INFO' },
    { name: 'vehicleAlarm', key: 'VEHICLE_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleDailyUsage', key: 'VEHICLE_DAILY_USAGE_MOTORCYCLE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_DAILY_USAGE.USED_OUTSIDE_HOUSEHOLD', value: 'USED_OUTSIDE_HOUSEHOLD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_DAILY_USAGE.NOT_USED_OUTSIDE_HOUSEHOLD', value: 'NOT_USED_OUTSIDE_HOUSEHOLD' },
        ]
      }
    },
    {
      name: 'vehicleDrivingLength', key: 'DRIVING_LENGTH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.16', value: '16000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.25', value: '25000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.30', value: '30000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.40', value: '40000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.50', value: '50000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.70', value: '70000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.100', value: '100000' }
        ]
      }
    },
    { name: 'vehicleDrivingLengthReadingKm', key: 'DRIVING_LENGTH_READING_KM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleDrivingLengthReadingDate', key: 'DRIVING_LENGTH_READING_DATE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'month'
      }
    },
    { name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'tffVehicleChassisNumber', key: 'TFF_VEHICLE_CHASSIS_NUMBER', group: 'OBJECT_INFO' },
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'tffVehicleTaxCode', key: 'TFF_VEHICLE_TAX_CODE', group: 'OBJECT_INFO' },
    { name: 'ofvFirstTimeRegYear', key: 'OFV_FIRST_TIME_REG_YEAR', group: 'OBJECT_INFO' },
  ],
  icon: 'motorcycle'
};
